/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'cross-flow-support.back-to-all-products': 'Back to all apps',
  'cross-flow-support.close': 'Close',
  'cross-flow-support.product-store': 'App store',
};
